import { getSelectedFacets, getSelectedPriceRangeFacet } from "../";
import { getSelectedFacetValues } from "../selectors";

export const selectSelectedFacets = getSelectedFacets;
export const selectSelectedFacetValues = getSelectedFacetValues;
export const selectPriceRangeFacet = getSelectedPriceRangeFacet;

export const selectDisplayedFacetValues = state => {
  const facetValues = selectSelectedFacetValues(state);
  const priceRangeFacet = selectPriceRangeFacet(state);

  return priceRangeFacet ? [...facetValues, priceRangeFacet] : facetValues;
};
